import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { FutureCredentialsInputDTORuntype, FutureResponseBodyDTORuntype } from './futureBackendTypes';

export const futureEndpoints = {
    'GET /3rdparty/future/credentials': endpoint({
        description: 'Returns credentials for future integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: FutureResponseBodyDTORuntype,
    }),
    'POST /3rdparty/future/credentials': endpoint({
        description: 'Uploads credentials for future API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: FutureCredentialsInputDTORuntype,
        responseBody: FutureResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/future/credentials'],
    }),
    'PATCH /3rdparty/future/credentials': endpoint({
        description: 'Updates credentials for future API integratoin',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: FutureCredentialsInputDTORuntype,
        responseBody: FutureResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/future/credentials'],
    }),
    'DELETE /3rdparty/future/credentials': endpoint({
        description: 'Deletes existing credentials for future API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/future/credentials'],
    }),
};
